import Vue from "vue";
import Router from "vue-router";
import utils from "@/assets/js/util";
import HelloWorld from "@/components/HelloWorld";
import Test from "@/view/test";
import Index from "@/view/index";
import AuthPage from "@/view/auth_page";
import UserAgreement from "@/view/user_agreement";
import UserRules from "@/view/user_rules";
import PayRecord from "@/view/pay_record";
import Contact from "@/view/contact";
import SuccessPay from "@/view/success_pay";
import Login from "@/view/login";
import Invoice from "@/view/invoice/index";
import InvoiceLog from "@/view/invoice/log";
import s27 from "@/view/s27";
import GameScore from "@/view/gamescore/index";
import GameScoreSearch from "@/view/gamescore/search";
import Winter from "@/view/winter";
import Demo from "@/view/demo";
import s28 from "@/view/s28";
import HeroEvo from "@/view/hero_evo";
import DtCup from "@/view/dt_cup";
import weekjd from "@/view/weekjd";
import s29 from "@/view/s29";
import s30 from "@/view/s30";
import s31 from "@/view/s31";
import NationalDay from "@/view/national_day";
import WinterLottery from "@/view/winter_lottery";
import s32 from "@/view/s32";
import s33 from "@/view/s33";
import newYearActivity from "@/view/2025/newYearActivity";
import s34 from "@/view/s34";
import s35 from "@/view/s35";
import welfare from "@/view/welfare";

Vue.use(Router);

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  } else {
    const position = {};
    if (to.hash) {
      position.selector = to.hash;
    }
    if (to.matched.some(m => m.meta.scrollToTop)) {
      position.x = 0;
      position.y = 0;
    }
    return position;
  }
};

const router = new Router({
  // base: '/dist',
  // mode: 'history',
  scrollBehavior,
  routes: [
    {
      path: "/hello",
      name: "HelloWorld",
      component: HelloWorld
    },
    {
      path: "/user_rules",
      name: "UserRules",
      component: UserRules,
      meta: {
        title: "09电竞-用户条例",
        keepAlive: false
      }
    },
    {
      path: "/user_agreement",
      name: "UserAgreement",
      component: UserAgreement,
      meta: {
        title: "09电竞-使用协议",
        keepAlive: false
      }
    },
    {
      path: "/auth_page",
      name: "AuthPage",
      component: AuthPage,
      meta: {
        title: "09电竞-授权页",
        keepAlive: false
      }
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        title: "09电竞-登录",
        keepAlive: false
      }
    },
    {
      path: "/",
      name: "Index",
      component: Index,
      meta: {
        title: "09电竞-个人中心",
        keepAlive: false
      }
    },
    {
      path: "/pay_record",
      name: "PayRecord",
      component: PayRecord,
      meta: {
        title: "充值/消费记录",
        keepAlive: false
      }
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact,
      meta: {
        title: "09电竞-联系客服",
        keepAlive: false
      }
    },
    {
      path: "/success_pay",
      name: "SuccessPay",
      component: SuccessPay,
      meta: {
        title: "09电竞-支付成功",
        keepAlive: false
      }
    },
    {
      path: "/invoice",
      name: "Invoice",
      component: Invoice,
      meta: {
        title: "09电竞-发票首页",
        keepAlive: false
      }
    },
    {
      path: "/invoice_log",
      name: "InvoiceLog",
      component: InvoiceLog,
      meta: {
        title: "09电竞-发票记录",
        keepAlive: false
      }
    },
    {
      path: "/s27",
      name: "s27",
      component: s27,
      meta: {
        title: "09电竞-s27赛季典藏",
        keepAlive: false
      }
    },
    {
      path: "/gamescore",
      name: "GameScore",
      component: GameScore,
      meta: {
        title: "09电竞-战绩中心",
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: "/gamescore/search",
      name: "GameScoreSearch",
      component: GameScoreSearch,
      meta: {
        title: "09电竞-战绩中心-搜索",
        keepAlive: false,
        isBack: false
      }
    },
    {
      path: "/winter",
      name: "Winter",
      component: Winter,
      meta: {
        title: "09电竞-岁末好礼",
        keepAlive: false
      }
    },
    {
      path: "/demo",
      name: "Demo",
      component: Demo,
      meta: {
        title: "09电竞-测试",
        keepAlive: false
      }
    },
    {
      path: "/s28",
      name: "s28",
      component: s28,
      meta: {
        title: "09电竞-s28赛季典藏",
        keepAlive: false
      }
    },
    {
      path: "/hero_evo",
      name: "HeroEvo",
      component: HeroEvo,
      meta: {
        title: "09电竞-切换账号",
        keepAlive: false
      }
    },
    {
      path: "/dt_cup",
      name: "DtCup",
      component: DtCup,
      meta: {
        title: "09平台-Dota龙虎杯2024",
        keepAlive: false
      }
    },
    {
      path: "/weekjd",
      name: "weekjd",
      component: weekjd,
      meta: {
        title: "09平台-瓜分酒豆",
        keepAlive: false
      }
    },
    {
      path: "/s29",
      name: "s29",
      component: s29,
      meta: {
        title: "09电竞-s29赛季典藏",
        keepAlive: false
      }
    },
    // {
    //   path: '/',
    //   redirect: 'gameCards'
    // },
    {
      path: "/gameCards",
      name: "gameCards",
      component: () => import("@/view/gameCards/index"),
      meta: {
        title: "09电竞-皮肤嘉年华",
        keepAlive: false
      }
    },
    {
      path: "/welfare",
      name: "welfare",
      component: welfare,
      meta: {
        title: "09电竞-皮肤嘉年华福利",
        keepAlive: false
      }
    },
    {
      path: "/s30",
      name: "s30",
      component: s30,
      meta: {
        title: "09电竞-s30赛季典藏",
        keepAlive: false
      }
    },
    {
      path: "/s31",
      name: "s31",
      component: s31,
      meta: {
        title: "09电竞-s31赛季典藏",
        keepAlive: false
      }
    },
    {
      path: "/national_day",
      name: "NationalDay",
      component: NationalDay,
      meta: {
        title: "09电竞-喜迎国庆",
        keepAlive: false
      }
    },
    {
      path: "/winter_lottery",
      name: "WinterLottery",
      component: WinterLottery,
      meta: {
        title: "09电竞-暖冬特惠",
        keepAlive: false
      }
    },
    {
      path: "/s32",
      name: "s32",
      component: s32,
      meta: {
        title: "09电竞-s32赛季典藏",
        keepAlive: false
      }
    },
    {
      path: "/s33",
      name: "s33",
      component: s33,
      meta: {
        title: "09电竞-s33赛季福利",
        keepAlive: false
      }
    },
    {
      path: "/s34",
      name: "s34",
      component: s34,
      meta: {
        title: "09电竞-s34赛季福利",
        keepAlive: false
      }
    },
    {
      path: "/s35",
      name: "s35",
      component: s35,
      meta: {
        title: "09电竞-s35赛季福利",
        keepAlive: false
      }
    },
    {
      path: "/newYearActivity",
      name: "newYearActivity",
      component: newYearActivity,
      meta: {
        title: "09电竞-蛇年新春活动",
        keepAlive: false
      }
    }
  ]
});

router.afterEach((to, from, next) => {
  utils.setTitle(to.meta.title);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js